module.exports = __webpack_public_path__ + "static/media/banner_wpi.17b1c9de.jpg";